import { createComponentStore } from '../../utils/createComponentStore';

// Output key must end with _ticketId (enforced by the backend validate()).
const keyAuto = () =>
  'ticket_' + (Math.floor(Math.random() * 90000000) + 10000).toString() + '_ticketId';

const initData = () => ({
  outputKey: keyAuto(),
  targetBoardId: null,
  title: '',
  fields: [],
});

const onLoadData = (rawData, component) => {
  const data = { ...initData(), ...rawData };
  if (!data.targetBoardId && component?.componentData?.targetBoardId) {
    data.targetBoardId = component.componentData.targetBoardId;
  }
  return data;
};

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'create_board_ticket',
  endpoint: 'create_board_ticket',
  registryKey: 'create_board_ticket',
  initData,
  onLoadData,

  extraState: () => ({
    placeholders: [],
    position: null,
  }),

  extraActions: (set, get) => ({
    setKey: (value) => set((s) => ({ data: { ...s.data, outputKey: value } })),
    setTitle: (title) => set((s) => ({ data: { ...s.data, title } })),
    setTargetBoardId: (targetBoardId) =>
      set((s) => ({ data: { ...s.data, targetBoardId } })),
    setFields: (fields) => set((s) => ({ data: { ...s.data, fields } })),
    clearFields: () => set((s) => ({ data: { ...s.data, fields: [] } })),
    keyAuto,
  }),
});

export { createStore as createCreateBoardTicketStore };
export const getCreateBoardTicketStore = getStore;
export default defaultStore;
